// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box_box_kDh0o {
}
`, "",{"version":3,"sources":["webpack://./src/components/box/box.css"],"names":[],"mappings":"AAAA;AACA","sourcesContent":[".box {\n}\n"],"sourceRoot":""}]);
// Exports
export var box = `box_box_kDh0o`;
export default ___CSS_LOADER_EXPORT___;
